import { render, staticRenderFns } from "./ByIngredients.vue?vue&type=template&id=74d38112&scoped=true&"
import script from "./ByIngredients.vue?vue&type=script&lang=js&"
export * from "./ByIngredients.vue?vue&type=script&lang=js&"
import style0 from "./ByIngredients.vue?vue&type=style&index=0&id=74d38112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d38112",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContainer,VDialog,VFlex,VLayout,VProgressCircular})
